import { type ContextSources } from '@air/api';

// These must match the query key constants in apps/core. React Query matches
// by key value, so keeping these aligned lets mutations here invalidate the
// queries defined in apps/core (and vice-versa) across the package boundary.
export const PRIVATE_CONTEXT_SOURCES_GET_KEY = 'PRIVATE_CONTEXT_SOURCES_GET';
export const WORKSPACES_LIST_KEY = 'WORKSPACES_LIST';

export const getPrivateContextSourcesGetKey = (params: Parameters<typeof ContextSources.get>[0]) => {
  return [PRIVATE_CONTEXT_SOURCES_GET_KEY, params];
};
